/// <reference lib="esnext" />
/// <reference lib="webworker" />

/**
 * Service-Worker-Quelle (Serwist).
 *
 * Ersetzt das frühere `next-pwa`-Setup: next-pwa ist unmaintained und
 * webpack-basiert, was mit Turbopack (Next.js 16 Default) nicht mehr baut.
 * Serwist kompiliert diese Datei über die Route `app/serwist/[path]/route.ts`
 * und liefert sie unter `/serwist/sw.js` aus.
 */

import { defaultCache } from '@serwist/turbopack/worker';
import type { PrecacheEntry, SerwistGlobalConfig } from 'serwist';
import { NetworkOnly, Serwist } from 'serwist';

declare global {
  interface WorkerGlobalScope extends SerwistGlobalConfig {
    __SW_MANIFEST: (PrecacheEntry | string)[] | undefined;
  }
}

declare const self: ServiceWorkerGlobalScope & WorkerGlobalScope;

const serwist = new Serwist({
  precacheEntries: self.__SW_MANIFEST,
  skipWaiting: true,
  clientsClaim: true,
  navigationPreload: true,
  runtimeCaching: [
    // `/cdn-cgi/*` gehört Cloudflare und wird am Edge behandelt (Zaraz,
    // Insights, Challenges). Der Service Worker darf das weder abfangen
    // noch cachen: die Standard-Strategie NetworkFirst versucht bei einem
    // fehlgeschlagenen Abruf einen Cache-Treffer, findet keinen und wirft
    // `no-response` als unbehandelte Promise-Ablehnung – sichtbar als
    // Fehler in der Konsole. Blockt eine Browser-Erweiterung Zaraz (was
    // häufig passiert), soll die Anfrage einfach still scheitern, so wie
    // ohne Service Worker auch.
    {
      matcher: ({ url }: { url: URL }) => url.pathname.startsWith('/cdn-cgi/'),
      handler: new NetworkOnly(),
    },
    ...defaultCache,
  ],
  fallbacks: {
    entries: [
      {
        url: '/~offline',
        matcher({ request }) {
          return request.destination === 'document';
        },
      },
    ],
  },
});

serwist.addEventListeners();
